(function setupChatPos() {
  const stickyEl = document.querySelector(".main-product .product-actions");

  function positionWidgets() {
    const widgetEl = document.querySelector("shopify-chat");
    const stickyCartEl = document.querySelector(".sticky-cart-toggle");
    const stickyElHeight = stickyEl.getBoundingClientRect().height;
    const widgetBottom = stickyElHeight + 10;

    document.body.style.setProperty("--chat-bottom", `${widgetBottom}px`);

    if (widgetEl) {
      widgetEl.classList.add("positioned");
    }

    if (stickyCartEl) {
      stickyCartEl.classList.add("positioned");
    }
  }

  function handleResize() {
    positionWidgets();
  }

  window.addEventListener("load", function () {
    positionWidgets();
  });

  new ResizeObserver(handleResize).observe(stickyEl);
})();
